import { render, staticRenderFns } from "./is-vip.vue?vue&type=template&id=494c55a3&scoped=true&"
import script from "./is-vip.vue?vue&type=script&lang=js&"
export * from "./is-vip.vue?vue&type=script&lang=js&"
import style0 from "./is-vip.vue?vue&type=style&index=0&id=494c55a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c55a3",
  null
  
)

export default component.exports